import { get } from 'lodash'
export default function(fields, id) {
  return {
    activityId: id,
    duration: get(fields, 'duration') * 60,
    startDate: get(fields, 'startDate'),
    description: get(fields, 'description'),
    weeksCount: get(fields, 'weeksCount'),
    fileUrls: fields && fields.fileUrls && fields.fileUrls.map(item => item.url)
  }
}
